import { ApiBase } from './ApiBase'
import {
  DashboardV2Period, IDashboardSubscription, IDashboardV2Data, IDashboardV2TeamDetail
} from './types/dashboardV2'
import { IDashboardEntry } from './types/user'

export default class DashboardApi extends ApiBase {
  public async addEntry(type: string) {
    const response = await this.post<IDashboardEntry>('/dashboards/add_entry', { dashboard_type: type })
    return response?.data
  }

  public async report<T>(id: string) {
    const response = await this.get<T>(`/dashboards/report/${id}`)
    return response?.data
  }

  public removeEntry(id: string) {
    return this.delete(`/dashboards/remove_entry/${id}`)
  }

  public async updateEntry(id: string, updatedEntry: IDashboardEntry) {
    const response = await this.put<IDashboardEntry>(`dashboards/update_entry/${id}`, updatedEntry)
    return response?.data
  }

  public async v2(period: DashboardV2Period, teamIds: number[] = []) {
    const response = await this.get<IDashboardV2Data>('/dashboard_v2', { period, team_ids: teamIds })
    return response?.data
  }

  public async v2Team(teamId: number, period: DashboardV2Period) {
    const response = await this.get<IDashboardV2TeamDetail>(`/dashboard_v2/teams/${teamId}`, { period })
    return response?.data
  }

  public async subscriptions() {
    const response = await this.get<IDashboardSubscription[]>('/dashboard_subscriptions')
    return response?.data
  }

  public async createSubscription(subscription: IDashboardSubscription) {
    const response = await this.post<IDashboardSubscription>('/dashboard_subscriptions', { dashboard_subscription: subscription })
    return response?.data
  }

  public async updateSubscription(id: number, changes: Partial<IDashboardSubscription>) {
    const response = await this.put<IDashboardSubscription>(`/dashboard_subscriptions/${id}`, { dashboard_subscription: changes })
    return response?.data
  }

  public async deleteSubscription(id: number) {
    const response = await this.delete(`/dashboard_subscriptions/${id}`)
    return response !== undefined
  }

  public async entries() {
    const response = await this.get<IDashboardEntry[]>('/dashboards/entries')
    return response?.data
  }
}
